// extracted by mini-css-extract-plugin
export default {"Box":"access-settings-view-module__Box__WLtwDfp","Heading":"access-settings-view-module__Heading__Cwc8pHj"};